// Provider annotations are language evidence, not a probe of media tracks.
const PT = '(?:pt(?:[-_ ]?(?:br|pt))?|por|portugu[eê]s(?:e)?)';
const separator = '[\\s:＝=._-]*';
const audio = new RegExp(`(?:audio|áudio|idioma|language|lang|dublado|dubbed)${separator}(?:em\\s+|in\\s+)?${PT}(?=$|[\\s\\].,;/_)-])`, 'i');
const subtitles = new RegExp(`(?:legendas?|legendado|subtitles?|subs|subbed)${separator}(?:em\\s+|in\\s+)?${PT}(?=$|[\\s\\].,;/_)-])`, 'i');
const subtitlesReverse = new RegExp(`${PT}${separator}(?:legendas?|legendado|subtitles?|subs|subbed)(?=$|[\\s\\].,;/_)-])`, 'i');
const tagged = new RegExp(`\\[${PT}\\]|\\(${PT}\\)`, 'i');
const subtitleWords = /(?:legendas?|legendado|subtitles?|\bsubs\b|subbed)/i;
const flags = /🇵🇹|🇧🇷/;

const portugueseSourceLanguage = (stream) => {
    if (!stream || typeof stream !== 'object') return null;
    const lines = [stream.name, stream.title, stream.description, stream.behaviorHints?.filename]
        .filter((value) => typeof value === 'string')
        .flatMap((value) => value.replace(/(?:https?:\/\/|magnet:)[^\s]+/gi, '').split(/\r?\n/));
    const hasSubtitles = lines.some((line) => subtitles.test(line) || subtitlesReverse.test(line) ||
        (subtitleWords.test(line) && flags.test(line)));
    const hasAudio = lines.some((line) => audio.test(line) ||
        (!subtitleWords.test(line) && (flags.test(line) || tagged.test(line))));
    return hasAudio ? 'audio' : hasSubtitles ? 'subtitles' : null;
};
const filterPortugueseStreams = (streams) => streams.flatMap((stream) => {
    const language = portugueseSourceLanguage(stream);
    if (!language) return [];
    return [{ ...stream, name: `${typeof stream.name === 'string' ? stream.name : 'Torrentio'}\n${language === 'audio' ? '[Português]' : 'Legendas: Português'}` }];
});
const isTorrentio = (addon) => {
    if (addon?.manifest?.id === 'com.stremio.torrentio.addon') return true;
    try { return new URL(addon?.transportUrl).hostname === 'torrentio.strem.fun'; } catch (_) { return false; }
};
const filterAddonResources = (resources) => resources.map((resource) => (
    isTorrentio(resource.addon) && resource.content?.type === 'Ready' && Array.isArray(resource.content.content)
        ? { ...resource, content: { ...resource.content, content: filterPortugueseStreams(resource.content.content) } }
        : resource
));

module.exports = { portugueseSourceLanguage, filterPortugueseStreams, filterAddonResources };
